import { useQuery } from "@tanstack/react-query";
import { VerificationRequestService } from "../../services";
import { asQuery } from "../../services/common";
import { DASH_STALE } from "./shared";

// The signed-in user's verification request (Profile page). Only fetched for
// users who aren't already verified (pass `enabled`).
export function useMyVerificationRequest(token?: string, enabled = true) {
  return useQuery({
    queryKey: ["verification-request", "mine", token],
    queryFn: () =>
      asQuery<any>(VerificationRequestService.getMine(token as string)),
    enabled: !!token && enabled,
    staleTime: DASH_STALE,
  });
}
